export type RecoveryCodesDownloadedAction = {
	type: 'RECOVERY_CODES_DOWNLOADED';
};

export default (): RecoveryCodesDownloadedAction => ({
	type: 'RECOVERY_CODES_DOWNLOADED',
});
